import { useEffect, useRef } from 'react';

import { useIsInView } from '@hooks/useIsInView';
import { useTrackingContext } from '@tracking/Provider/Context';
import { useTrackSignupContractExpiryDatePromoDisplayedOnce } from '@tracking/trackingEvents';

import { RenewalCaptureForm } from './RenewalCaptureForm';

const CarInsurance = () => {
  const formRef = useRef<HTMLDivElement>(null);
  const isInView = useIsInView(formRef);

  const { trackingContexts } = useTrackingContext();
  const trackPromoDisplayed =
    useTrackSignupContractExpiryDatePromoDisplayedOnce();

  useEffect(() => {
    if (isInView) {
      trackPromoDisplayed(
        { product: 'CarInsurance' },
        { contexts: trackingContexts }
      );
    }
  }, [isInView, trackPromoDisplayed, trackingContexts]);

  return (
    <RenewalCaptureForm
      field="renewalCarInsuranceDate"
      ref={formRef}
      label="Car insurance renewal date"
    />
  );
};

export { CarInsurance };
